import {Component, Input} from '@angular/core';
import {Faq} from '@npck/af-frontend-api';

@Component({
    selector: 'af-faq-answers',
    templateUrl: 'faq-answers.component.html',
    styleUrls: ['faq-answers.component.scss'],
    standalone: false,
})
export class FaqAnswersComponent {
    @Input() faqs: Faq[] = [];
}
